import localhost from "apis/localhost";

export const BASE_API_PATH = "/api/notification-settings";

export const fetchNotificationSettings = async () => {
  const response = await localhost.get(BASE_API_PATH);
  return response?.data;
};

export const TRACKED_OPPORTUNITY_UPDATE_API_PATH = `${BASE_API_PATH}/tracked-opportunity-update`;

export const updateTrackedOpportunityUpdate = async (enabled) => {
  const response = await localhost.put(TRACKED_OPPORTUNITY_UPDATE_API_PATH, {
    enabled,
  });
  return response?.data;
};

export const updateNotificationSettings = async (deadlineLeadTimeDays) => {
  const response = await localhost.put(BASE_API_PATH, {
    deadlineLeadTimeDays,
  });
  return response?.data;
};
